import { createStore } from 'vuex';

const store = createStore({
  state: {
    user: null,
    token: null,
    refreshToken: null,
    isLogin: false,
    tokenExpiry: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isLogin = !!user;
    },
    setToken(state, { token, refreshToken, expiry }) {
      state.token = token;
      state.refreshToken = refreshToken;
      state.tokenExpiry = expiry;
      state.isLogin = !!token;
    },
    updateUser(state, updatedUser) {
      state.user = updatedUser;
    },
    initialiseStore(state) {
      const storeData = localStorage.getItem('store');
      if (storeData) {
        const parsedStore = JSON.parse(storeData);
        if (parsedStore.tokenExpiry && new Date(parsedStore.tokenExpiry) > new Date()) {
          store.replaceState(Object.assign(state, parsedStore));
        } else {
          localStorage.removeItem('store');
        }
      }
    },
  },
  actions: {
    login({ commit }, { user}) {
      commit('setUser', user);
    },
    logout({ commit }) {
      commit('setUser', null);
      commit('setToken', { token: null, refreshToken: null, expiry: null });
    },
  },
  getters: {
    isAuthenticated: state => state.isLogin,
    getUser: state => state.user,
    getToken: state => state.token,
    getRefreshToken: state => state.refreshToken,
    getExpiry : state =>state.tokenExpiry
  },
});

// 订阅 store 的变化，并同步到 localStorage
store.subscribe((mutation, state) => {
  localStorage.setItem('store', JSON.stringify(state));
});

export default store;
